<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>结课学生列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="12">
            <Form-item label="结课时间">
              <Row>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="startFinishedTimeChange" style="width: 100%;"/>
                </Col>
                <Col span="2" style="text-align: center">-</Col>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="endFinishedTimeChange" style="width: 100%;"/>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学导：">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser"
                                 v-model="queryParam.adminUserId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="课程顾问：">
              <admin-user-select :status="1" adminGroupCode="adviser"
                                 v-model="queryParam.adviserId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学员ID：">
              <Input name="uid" v-model="queryParam.uid" placeholder="不支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生姓名：">
              <Input name="nickname" v-model="queryParam.nickname" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生手机号：">
              <Input name="mobile" v-model="queryParam.mobile" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Row>
              <Form-item label="一级原因">
                <Select v-model="queryParam.remark" placeholder="请选择">
                  <Option v-for="item in $constant.stdOverRemark"
                          :value="item.text" :key="item.text">{{ item.text }}</Option>
                </Select>
              </Form-item>
            </Row>
          </Col>
          <Col :span="6">
            <Form-item>
              <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                      @click="search">搜索
              </Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Row>
        <Col>
          <Button type="primary" @click="onAssignAdviser">解绑学导</Button>
          <Button type="primary" :loading="cancelLoading" :disable="cancelLoading" icon=""
                  @click="batchCancel">批量取消结课
          </Button>
          <Button type="primary" @click="onBatchCompletedCourses">批量结课</Button>
          <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search" v-perm="'602'"
                  @click="exportData">导出
          </Button>
        </Col>
      </Row>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/user/overClass/list"
          :params="queryParam" :onLoading="onLoading" @on-selection-change="selectionChange"></List>
    <UnBinStudyModal :successCallback="search" :userList="selectionUser"
                     v-model="showUnBinStudyModal"></UnBinStudyModal>

    <BatchCompletedCoursesModal :successCallback="search"
                                v-model="showBatchCompletedCoursesModal"></BatchCompletedCoursesModal>
    <EditOverRemarkModal :successCallback="search" @on-close="closeComplaintModal" :complaintRow="this.complaintRow"
                         :visible="showUpdateScoreModal"></EditOverRemarkModal>
  </div>
</template>

<script>
import UnBinStudyModal from './UnBinStudyModal.vue'
import BatchCompletedCoursesModal from './BatchCompletedCoursesModal.vue'
import EditOverRemarkModal from './modal/EditOverRemarkModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

export default {
  components: {
    EditOverRemarkModal,
    UnBinStudyModal,
    BatchCompletedCoursesModal,
  },
  name: 'UserRefundList',
  data () {
    let $constant = this.$constant
    return {
      timer: '',
      smsCode: '',
      time: 60,
      disabled: false,
      exportLoading: false,
      cancelLoading: false,
      selectionUser: [],
      searchLoading: false,
      showUnBinStudyModal: false,
      showUpdateScoreModal: false,
      complaintRow: null,
      complaintRemarkList: $constant.stdOverRemark,
      showBatchCompletedCoursesModal: false,
      reload: 0,
      rankScoreSeq: 0,
      queryParam: {
        startFinishedTime: null,
        endFinishedTime: null,
        uid: '',
        adviserName: '',
        nickname: '',
        mobile: '',
        studyAdviserName: '',
        stdStatus: 8
      },
      regDateRange: [],
      title: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '学生ID/姓名',
          width: 150,
          align: 'center',
          fixed: 'left',
          render: (h, params) => {
            let row = params.row
            return h('span', row.id + '-' + row.nickname)
          }
        },
        {
          title: '手机号',
          width: 130,
          align: 'center',
          key: 'mobile',
          render: (h, params) => {
            return h('Poptip', {
              props: {
                trigger: 'hover'
              }
            }, [
              h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) +
                '****' + params.row.mobile.substring(7) : params.row.mobile),
              // 当前行展示的数据
              h('div', {slot: 'content'}, params.row.mobile)
            ])
          }
        },
        {
          title: '班主任老师',
          width: 200, // 合并后列的总宽度
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('p', `学导：${params.row.studyAdviserName || ''}`),
              h('p', `课程顾问：${params.row.adviserName || ''}`),
              h('p', `老师对应外管：${params.row.tchAdviserNickname || ''}`)
            ])
          }
        },
        {
          title: '绑定老师',
          width: 180,
          align: 'center',
          key: 'tchName',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchName,
              score: row.monthRankScore
            })
          }
        },
        {
          title: '注册渠道',
          width: 120,
          align: 'center',
          key: 'regType',
        },
        {
          title: '最后一个订单总课时',
          width: 170,
          align: 'center',
          render: (h, params) => {
            const value = params.row.lastOrderTotalClassHour
            return h('span', value === null || value === undefined ? '-' : value)
          }
        },
        {
          title: '时间信息',
          width: 340, // 合并后列的总宽度
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('p', `注册时间：${params.row.gmtCreate || ''}`),
              h('p', `结课时间：${params.row.finishedTime || ''}`)
            ])
          }
        },
        {
          title: '不续费原因',
          width: 340,
          align: 'left',
          render: (h, params) => {
            const attachmentUrls = params.row.overRemark && params.row.overRemark.attachmentUrls
            let imageElements = []
            if (attachmentUrls) {
              // 将逗号分隔的字符串拆分为数组
              const urls = attachmentUrls.split(',').filter(url => url.trim())
              urls.forEach((url, index) => {
                imageElements.push(h('img', {
                  attrs: {
                    src: 'https://imgs.kouyujie.cn/' + url.trim()
                  },
                  style: {
                    width: '50px',
                    height: '50px',
                    marginRight: '5px',
                    marginBottom: '5px',
                    objectFit: 'cover',
                    cursor: 'pointer',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  },
                  on: {
                    click: () => {
                      // 点击图片时在新窗口打开
                      window.open('https://imgs.kouyujie.cn/' + url.trim(), '_blank')
                    }
                  }
                }))
              })
            }

            return h('div', [
              h('p', `一级原因：${params.row.overRemark.remark || ''}`),
              h('p', `其他原因：${params.row.overRemark.remarkExt || ''}`),
              attachmentUrls ? h('div', {
                style: {
                  marginTop: '5px',
                  display: 'flex',
                  flexWrap: 'wrap'
                }
              }, imageElements) : null
            ])
          }
        },
        {
          title: '等级',
          width: 120,
          align: 'center',
          key: 'levelTitle'
        },
        {
          title: '付款与状态',
          width: 200, // 合并后列的总宽度
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('p', `是否付款：${params.row.isPay === 1 ? '是' : '否'}`),
              h('p', `用户状态：${params.row.status === 1 ? '激活' : '停用'}`)
            ])
          }
        },
        {
          title: '资源状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let resourceStatus = params.row.resourceStatus
            let resourceStatusEnum = $constant.getEnum($constant.resourceStatus, resourceStatus)
            return h('span', resourceStatusEnum && resourceStatusEnum.text)
          }
        },
        // {
        //   title: '学生状态',
        //   width: 100,
        //   align: 'center',
        //   render: (h, params) => {
        //     let studentStatus = params.row.studentStatus
        //     let studentStatusEnum = $constant.getEnum($constant.studentStatus, studentStatus)
        //     return h('span', studentStatusEnum && studentStatusEnum.text)
        //   }
        // },
        // {
        //   title: '学员状态',
        //   width: 100,
        //   align: 'center',
        //   render: (h, params) => {
        //     let stdStatus = params.row.stdStatus
        //     let stdStatusEnum = $constant.getEnum($constant.stdStatus, stdStatus)
        //     return h('span', stdStatusEnum && stdStatusEnum.text)
        //   }
        // }
        {
          title: '操作',
          align: 'center',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h('a', {
                on: {
                  click: () => {
                    this.onUpdateComplaint(params.row)
                  }
                }
              }, '不续费原因')
            ])
          }
        }
      ]
    }
  },
  methods: {
    closeComplaintModal (val) {
      this.showUpdateScoreModal = false
      this.complaintRow = {}
    },
    onUpdateComplaint (row) {
      this.showUpdateScoreModal = true
      this.complaintRow = row
    },
    exportData (type) {
      this.exportLoading = true
      this.$http.get('/user/overClass/exportExcel', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '结课学生.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    onAssignAdviser () {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需要解绑的学生！')
        return
      }
      this.showUnBinStudyModal = true
    },

    onBatchCompletedCourses () {
      this.showBatchCompletedCoursesModal = true
    },
    selectionChange (selection) {
      this.selectionUser = selection
    },
    search () {
      this.reload = new Date().getTime()
    },
    startFinishedTimeChange (value) {
      this.queryParam.startFinishedTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endFinishedTimeChange (value) {
      this.queryParam.endFinishedTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
        onLoading (loading) {
      this.searchLoading = loading
    
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },
    batchCancel () {
      let self = this
      this.cancelLoading = true
      let ids = []
      let user = null
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (let i in this.selectionUser) {
          let dto = this.selectionUser[i]
          user = dto
          ids[i] = dto.id
        }
      } else {
        self.$Message.warning('请选择目标')
        this.cancelLoading = false
        return
      }
      this.$Modal.confirm({
        title: '[' + user.id + '-' + user.nickname + ']' + '>>取消结课',
        width: 300,
        okText: '确定',
        loading: true,
        render: (h, params) => {
          return h('div', [
            h('Input', {
              props: {
                placeholder: '请输入复课原因'
              },
              on: {
                input: (e) => {
                  self.remark = e
                }
              }
            }),
            h('Button', {
              attrs: {disabled: self.disabled},
              on: {
                click: () => {
                  self.$http.get('/userinfo/sendUpdateMobileSmsCode', {params: {uid: user.id, key: 'call_back_from_stop_sms'}}).then(res => {
                    if (res.status === 'ok') {
                      self.disabled = true
                      self.$Message.success('验证码发送成功!')
                      self.timer = setInterval(() => {
                        if (self.time <= 0) {
                          self.disabled = false
                          self.time = 60
                          clearInterval(this.timer)
                        } else {
                          self.time -= 1
                        }
                      }, 1000)
                    }
                  })
                }
              }
            }, self.disabled ? (self.time + '秒') : '发送验证码'),
            h('Input', {
              props: {
                placeholder: '短信验证码'
              },
              on: {
                input: (e) => {
                  self.smsCode = e
                }
              }
            }),
          ])
        },
        onOk: () => {
          this.$http.post('/user/lessonsStop/batchCancelUserStopLesson', {
            ids: ids.join(','),
            remark: this.remark,
            isStop: 2,
            smsCode: this.smsCode
          }).then((res) => {
            if (res && res.data > 0) {
              self.$Message.success('移出申请已提交')
              self.cancelLoading = false
              self.search()
              self.$Modal.remove()
            } else {
              self.$Message.error('批量移出失败！')
              self.cancelLoading = false
              self.$Modal.remove()
            }
          }).catch((e) => {
            this.cancelLoading = false
          })
        },
        onCancel: () => {
          this.cancelLoading = false
          self.time = 60
          clearInterval(this.timer)
          self.disabled = false
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.btn-wrap {
  text-align: right;
  margin-top: 24px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// UserOverClassList.vue?74ac1fc2